import { Controller } from "@hotwired/stimulus"
import Sortable from "sortablejs"

// Builder d'un plan d'action (axe -> sous-axe -> action -> indicateur).
// - add(btn)       : POST de création puis reload (insertion structurelle simple/robuste)
// - saveField(el)  : PATCH autosave d'un champ inline (titre, statut, dates, indicateurs...)
// - destroy(btn)   : DELETE puis retrait du noeud
// - reorder        : SortableJS par conteneur [data-reorder-url], PATCH des positions
export default class extends Controller {
  connect() {
    this.sortables = []
    this.element.querySelectorAll("[data-reorder-url]").forEach(container => {
      this.sortables.push(Sortable.create(container, {
        animation: 150,
        handle: container.dataset.reorderHandle || ".pab-drag",
        draggable: container.dataset.reorderItem || ".pab-sortable",
        ghostClass: "pab-ghost",
        onEnd: () => this._reorder(container)
      }))
    })
    this._restoreCollapsed()
  }

  disconnect() {
    this.sortables?.forEach(s => s.destroy())
  }

  async add(event) {
    const btn   = event.currentTarget
    const param = btn.dataset.param
    let payload = {}
    try { payload = JSON.parse(btn.dataset.payload || "{}") } catch (e) {}
    btn.disabled = true
    const res = await this._req(btn.dataset.createUrl, "POST", { [param]: payload })
    if (res.ok) {
      window.location.reload()
    } else {
      btn.disabled = false
      alert("L'ajout n'a pas pu être réalisé.")
    }
  }

  async saveField(event) {
    const el    = event.currentTarget
    const param = el.dataset.param
    const field = el.dataset.field
    const value = el.type === "checkbox" ? el.checked : el.value
    el.classList.remove("is-saved", "is-error")
    el.classList.add("is-saving")
    const res = await this._req(el.dataset.url, "PATCH", { [param]: { [field]: value } })
    el.classList.remove("is-saving")
    el.classList.add(res.ok ? "is-saved" : "is-error")
    // Certains champs (le type d'un indicateur/objectif) changent les champs de
    // valeur affichés : on recharge pour re-rendre la bonne saisie.
    if (res.ok && el.dataset.reload === "true") { window.location.reload(); return }
    setTimeout(() => el.classList.remove("is-saved", "is-error"), 1100)
  }

  // Plier / déplier un axe ou un sous-axe (état mémorisé en localStorage pour
  // survivre aux rechargements déclenchés par les ajouts).
  toggleCollapse(event) {
    const box = event.currentTarget.closest("[data-collapsible]")
    if (!box) return
    const collapsed = box.classList.toggle("is-collapsed")
    this._storeCollapsed(box.dataset.collapsible, box.dataset.id, collapsed)
  }

  _collapseKey(kind, id) { return `pab-collapse:${kind}:${id}` }

  _storeCollapsed(kind, id, collapsed) {
    try { window.localStorage.setItem(this._collapseKey(kind, id), collapsed ? "1" : "0") } catch (e) {}
  }

  _restoreCollapsed() {
    this.element.querySelectorAll("[data-collapsible]").forEach(box => {
      let v = null
      try { v = window.localStorage.getItem(this._collapseKey(box.dataset.collapsible, box.dataset.id)) } catch (e) {}
      if (v === "1") box.classList.add("is-collapsed")
    })
  }

  async destroy(event) {
    const btn = event.currentTarget
    if (!confirm(btn.dataset.confirm || "Supprimer ?")) return
    const res = await this._req(btn.dataset.url, "DELETE", {})
    if (res.ok) {
      btn.closest(btn.dataset.remove)?.remove()
    } else {
      alert("La suppression a échoué.")
    }
  }

  async _reorder(container) {
    const ids = Array.from(container.children)
      .map(c => c.dataset.id)
      .filter(Boolean)
    if (!ids.length) return
    await this._req(container.dataset.reorderUrl, "PATCH", { ids })
  }

  async _req(url, method, body) {
    const csrf = document.querySelector('meta[name="csrf-token"]')?.content
    try {
      return await fetch(url, {
        method,
        headers: { "Content-Type": "application/json", "Accept": "application/json", "X-CSRF-Token": csrf || "" },
        body: JSON.stringify(body)
      })
    } catch (e) {
      return { ok: false }
    }
  }
}
